import { Icon } from '@studio/design-system/icon';
import { Label } from '@studio/design-system/label';
import { Container, Archetype as Switch } from '@studio/design-system/switch';
import { useInterval } from '@studio/react-utils/hooks';
import { random } from 'lodash-es';
import { useCallback, useState } from 'react';
import type { ReactElement } from 'react';
import { Column, Exhibit } from './styled.jsx';

type State = [boolean, boolean, boolean];

/** `<Switches>` exhibit. */
export const Switches = (): ReactElement => {
  const [state, setState] = useState<State>([true, false, false]);

  useInterval(() => {
    setState((µ) => [!µ[0], !µ[1], !!(random(1, 10) % 2)]);
  }, 3e3);

  const handleChange = useCallback(
    (position: number) => (nextValue: boolean) => {
      setState(
        (µ) =>
          µ.map((currentValue, index) => (index === position ? nextValue : currentValue)) as State
      );
    },
    []
  );

  return (
    <Exhibit title='Switches'>
      <Column>
        <Container label='Cheesy'>
          <Switch checked={state[0]} onCheckedChange={handleChange(0)} />
        </Container>

        <Container label='Eccentric'>
          <Switch checked={state[1]} onCheckedChange={handleChange(1)} />
        </Container>

        <Container label='Quirky'>
          <Switch checked={state[2]} onCheckedChange={handleChange(2)} />
        </Container>

        <Container label='Whimsical'>
          <Switch defaultChecked={false} disabled offLabel='no' onLabel='yes' />
        </Container>

        <Container
          label={
            <Label>
              Zesty
              <Icon className='text-md' icon='alert-circle' />
            </Label>
          }
        >
          <Switch defaultChecked disabled />
        </Container>
      </Column>
    </Exhibit>
  );
};
